const generateDefaultFooterState = () => ({
  columns: [],
})

const footerState = (state = generateDefaultFooterState(), action) => {
  let newState;

  switch (action.type) {
    case 'GET_FOOTER_ITEMS_FULFILLED': {
      newState = {
        ...state,
        columns: action.payload?.response?.data?.result?.columns
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default footerState;
export {generateDefaultFooterState};
